import { CollectionEntity } from "@busy-human/gearbox";
export var AmtUser;
(function (AmtUser) {
    function amtUserDefaults() {
        return {
            name: null,
            email: null,
            companyId: null,
            active: true,
            presets: {
                incidentType: null,
                facility: null
            },
            phone: '',
            companyName: ''
        };
    }
    class CollectionClass extends CollectionEntity {
        relationships;
        defaults() {
            return amtUserDefaults();
        }
    }
    AmtUser.CollectionClass = CollectionClass;
    AmtUser.AmtUsers = new CollectionClass({ path: "/AmtUsers" });
})(AmtUser || (AmtUser = {}));
//# sourceMappingURL=index.js.map